/**
 * NavbarIcon Component
 *
 * Reusable icon component for navbar items
 * Follows Single Responsibility Principle
 */

import React, { useState } from 'react';
import Image from 'next/image';

export interface NavbarIconProps {
  iconName: string;
  size?: number;
  className?: string;
  alt?: string;
}

const ICON_PATH = '/assets/images/icons/navbar';

export const NavbarIcon: React.FC<NavbarIconProps> = ({
  iconName,
  size = 20,
  className = '',
  alt = '',
}) => {
  const [imgError, setImgError] = useState(false);
  const iconSrc = `${ICON_PATH}/${iconName}.svg`;

  if (imgError) {
    // Fallback: return a placeholder div if image fails to load
    return (
      <div
        style={{
          width: size,
          height: size,
          backgroundColor: '#E7E5E4',
          borderRadius: '4px',
        }}
        className={className}
        aria-label={alt || iconName}
      />
    );
  }

  return (
    <div
      style={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
      className={className}
    >
      <Image
        src={iconSrc}
        alt={alt || iconName}
        width={size}
        height={size}
        onError={() => setImgError(true)}
        unoptimized
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  );
};
